"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.versioned = void 0;
exports.versioned = [
    {
        minmax: [0, undefined],
        types: {
        // nothing, limited runtime
        }
    }
];
